<script setup>
import { Link } from '@inertiajs/vue3';
import { ref, onMounted, onUnmounted } from 'vue';
import PlusIcon from '@/Components/Icons/PlusIcon.vue';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    routeName: {
        type: String,
        required: true
    },
    active: {
        type: Boolean,
        default: false
    },
    children: {
        type: Array,
        default: () => []
    }
});

const isDropdownOpen = ref(false);
const isMobile = ref(false);

const checkScreenSize = () => {
    isMobile.value = window.innerWidth <= 1024;
};

onMounted(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
});

onUnmounted(() => {
    window.removeEventListener("resize", checkScreenSize);
});

const toggleDropdown = () => {
    if (isMobile.value) {
        isDropdownOpen.value = !isDropdownOpen.value;
    }
};
</script>

<template>
    <li class="relative"
        @mouseenter="!isMobile && (isDropdownOpen = true)"
        @mouseleave="!isMobile && (isDropdownOpen = false)"
    >
        <component
            :is="children.length ? 'button' : Link"
            @click="toggleDropdown"
            :href="!children.length ?  route(routeName) : null"
            :class="[
                active ? 'text-primaryColor font-bold' : 'text-black',
                isMobile ? 'flex justify-between items-center w-full pr-2' : ''
            ]"
             class="block py-1 xl:py-2 hover:text-primaryColor nav-title"
        >
            {{ title }}
            <PlusIcon v-if="isMobile && children.length" :size="'20'" :color="'#577BE9'" :class="{'rotate-45': isDropdownOpen}" />
        </component>

        <transition name="fade-slide">
            <ul
                v-if="children.length"
                v-show="isDropdownOpen"
                :class="[isMobile ? 'relative py-1 mt-1' : 'absolute left-0 py-1 bg-white shadow-lg rounded-md border z-10 overflow-hidden']"
                class="transition-all duration-300 ease-out transform origin-top"
            >
                <li v-for="(child, index) in children" :key="index">
                    <Link :href="child.params ? route(child.routeName, child.params) : route(child.routeName)" class="block px-4 py-2 hover:bg-gray-100 text-nowrap text-primary hover:text-primaryColor nav-title">
                        {{ child.title }}
                    </Link>
                </li>
            </ul>
        </transition>
    </li>
</template>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.2s ease-out;
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateY(-10px);
}

.fade-slide-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.fade-slide-leave-from {
    opacity: 1;
    transform: translateY(0);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.nav-title {
  transition: transform 0.2s ease-in-out;
}

@media (min-width: 768px) {
  .nav-title:hover {
    transform: scale(1.05);
  }
}
</style>

